import SectionHeading from '@/components/base/SectionHeading';
import StoryCard from '@/pages/home/components/StoryCard';
import { featuredStories } from '@/mocks/homeData';

export default function FeaturedSection() {
  const [lead, ...rest] = featuredStories;

  return (
    <section id="featured" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto px-4 md:px-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="EDITOR'S PICK"
            title="本周热门推荐"
            desc="编辑组从近期收录中挑出的六篇，既有悬而未决的旧案，也有让人哭笑不得的日常迷惑。"
          />
          <a
            href="#latest"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部收录
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-12">
          <StoryCard story={lead} featured />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((story) => (
            <StoryCard key={story.id} story={story} />
          ))}
        </div>
      </div>
    </section>
  );
}